module.exports = __webpack_public_path__ + "img/gl.77ad3e8d.png";